import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
    selector: '[appMaskIfNotLoggedIn]'
})
export class MaskIfNotLoggedInDirective implements OnInit {
    @Input('appMaskIfNotLoggedIn') isShow: boolean = false;
    @Input() messageText: string = 'Login to view';
    @Input() loginCallback: () => void = () => { };

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        const host = this.el.nativeElement;
        this.renderer.setStyle(host, 'position', 'relative');

        if (this.isShow) {
            // Dim the host element
            //   this.renderer.setStyle(host, 'opacity', '0.5');
            this.renderer.setStyle(host, 'pointer-events', 'none');

            

            // Create clickable overlay container
            const overlay = this.renderer.createElement('div');
            this.renderer.setStyle(overlay, 'border', '1px solid #d2962f');
            this.renderer.setStyle(overlay, 'position', 'absolute');
            this.renderer.setStyle(overlay, 'top', '0');
            this.renderer.setStyle(overlay, 'left', '0');
            this.renderer.setStyle(overlay, 'right', '0');
            this.renderer.setStyle(overlay, 'bottom', '0');
            this.renderer.setStyle(overlay, 'background', 'rgba(255,244,189,0.7)');
            this.renderer.setStyle(overlay, 'backdrop-filter', 'blur(2px)');
            this.renderer.setStyle(overlay, 'z-index', '1000');
            this.renderer.setStyle(overlay, 'display', 'flex');
            this.renderer.setStyle(overlay, 'flex-direction', 'column');
            this.renderer.setStyle(overlay, 'align-items', 'center');
            this.renderer.setStyle(overlay, 'justify-content', 'center');
            this.renderer.setStyle(overlay, 'pointer-events', 'auto');
            this.renderer.setStyle(overlay, 'display', 'flex');
            this.renderer.setStyle(overlay, 'flex-direction', 'row');
            this.renderer.setStyle(overlay, 'gap', '5px');
            this.renderer.setStyle(overlay, 'justify-content', 'space-between');
            this.renderer.setStyle(overlay, 'padding', '10px');

            // Message
            const message = this.renderer.createElement('div');
            const messageText = this.renderer.createText(this.messageText);
            this.renderer.appendChild(message, messageText);
            this.renderer.setStyle(message, 'color', '#1a1a1a');
            this.renderer.setStyle(message, 'font-size', '#1a1a1a');

            // Button
            const button = this.renderer.createElement('button');
            const buttonText = this.renderer.createText('Login');
            this.renderer.appendChild(button, buttonText);
            this.renderer.setAttribute(button, 'type', 'button');
            this.renderer.setStyle(button, 'padding', '6px 12px');
            this.renderer.setStyle(button, 'border', 'none');
            this.renderer.setStyle(button, 'background', '#4285F4');
            this.renderer.setStyle(button, 'color', '#fff');
            this.renderer.setStyle(button, 'border-radius', '4px');
            this.renderer.setStyle(button, 'cursor', 'pointer');

            // Add click handler
            this.renderer.listen(button, 'click', () => {
                this.loginCallback();
            });

            // Append to overlay
            this.renderer.appendChild(overlay, message);
            this.renderer.appendChild(overlay, button);

            // Add overlay to host
            this.renderer.appendChild(host, overlay);
        }
    }
}
